import { Box } from '@mui/material';
import React from 'react';
import { useIntl } from 'react-intl';
import { SectionTitle } from '../SectionTitle';
import { LanguageSwitcher } from './LanguageSwitcher';

export const LanguageSettingsSection: React.FC = () => {
  const { formatMessage } = useIntl();

  return (
    <Box padding={2}>
      <SectionTitle title={formatMessage({ id: 'Language' })} />
      <LanguageSwitcher />
    </Box>
  );
};